const storageKeyOf = (userUuid: string) => `customer_view_started_at_${userUuid}`;

const startedAtMsKeptInMemory = new Map<string, number>();
const listeners = new Set<() => void>();

const notifyListeners = () => listeners.forEach((listener) => listener());

const callStorage = <Result>(call: (storage: Storage) => Result): Result | undefined => {
  try {
    return call(window.localStorage);
  } catch {
    return undefined;
  }
};

const parseStartedAtMs = (raw: string | null | undefined): number | null => {
  if (raw === null || raw === undefined) return null;
  const startedAtMs = Number(raw);
  return Number.isFinite(startedAtMs) ? startedAtMs : null;
};

export const readCustomerViewStartedAtMs = (userUuid: string): number | null =>
  parseStartedAtMs(callStorage((storage) => storage.getItem(storageKeyOf(userUuid)))) ??
  startedAtMsKeptInMemory.get(userUuid) ??
  null;

export const writeCustomerViewStartedAtMs = (userUuid: string, startedAtMs: number) => {
  const isStored =
    callStorage((storage) => {
      storage.setItem(storageKeyOf(userUuid), String(startedAtMs));
      return true;
    }) === true;
  if (isStored) {
    startedAtMsKeptInMemory.delete(userUuid);
  } else {
    startedAtMsKeptInMemory.set(userUuid, startedAtMs);
  }
  notifyListeners();
};

export const clearCustomerViewStartedAtMs = (userUuid: string) => {
  startedAtMsKeptInMemory.delete(userUuid);
  callStorage((storage) => storage.removeItem(storageKeyOf(userUuid)));
  notifyListeners();
};

export const subscribeToCustomerView = (listener: () => void) => {
  listeners.add(listener);
  window.addEventListener('storage', listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('storage', listener);
  };
};
